import Columns from './columns';
import {displayModes} from '../../../../../services/enums/displayModes';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {
      // This column is also used as a draggable handler and thus should never be optional or removed!!
      tourTemplateNumber: {
        columnName: Columns.tourTemplateNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      tourTemplateId: {
        columnName: Columns.tourTemplateId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      tourTemplateCustomers: {
        columnName: Columns.tourTemplateCustomers.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      tourTemplateApplyAtMin: {
        columnName: Columns.tourTemplateApplyAtMin.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      tourTemplateMaxApplicable: {
        columnName: Columns.tourTemplateMaxApplicable.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {
      // This column is also used as a draggable handler and thus should never be optional or removed!!
      tourTemplateNumber: {
        columnName: Columns.tourTemplateNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      tourTemplateId: {
        columnName: Columns.tourTemplateId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      tourTemplateCustomers: {
        columnName: Columns.tourTemplateCustomers.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      tourTemplateApplyAtMin: {
        columnName: Columns.tourTemplateApplyAtMin.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      tourTemplateMaxApplicable: {
        columnName: Columns.tourTemplateMaxApplicable.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
}

export default DefaultConfig;